var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEGeneralEmissionTabsRoom = function SvgEGeneralEmissionTabsRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 459.94,
    width: 4,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 459.94,
    width: 4,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 167.95,
    width: 4,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 167.95,
    width: 4,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 168.02,
    width: 4,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 168.02,
    width: 4,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 459.94,
    width: 4,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 459.94,
    width: 4,
    height: 4,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M574,470H110V162h464v308ZM558,178H126v276h432V178Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572,468H112V164h460v304ZM560.01,176H124v279.98h436V176Z",
    fill: "#c3c3c3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "318 344 318 272 366 272",
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "366 272 366 344 318 344",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.63 281.68 322.66 280.47 322 280.73 322.12 281.47 324.08 282.66 322.52 283.61 322.4 284.36 323.07 284.6 325.17 283.32 328.67 285.45 325.17 287.59 323.07 286.3 322.4 286.55 322.52 287.3 324.08 288.24 322.12 289.44 322 290.17 322.66 290.44 324.63 289.23 324.63 291.14 325.17 291.63 325.72 291.14 325.72 288.58 329.21 286.45 329.21 290.71 327.11 291.99 326.98 292.72 327.65 292.99 329.21 292.03 329.21 294.42 329.76 294.91 330.29 294.42 330.29 292.03 331.86 292.99 332.52 292.72 332.4 291.99 330.29 290.71 330.29 286.45 333.8 288.58 333.8 291.14 334.34 291.63 334.88 291.14 334.88 289.23 336.85 290.44 337.52 290.17 337.39 289.44 335.42 288.24 336.98 287.3 337.11 286.55 336.44 286.3 334.34 287.59 330.84 285.45 334.34 283.32 336.44 284.6 337.11 284.36 336.98 283.61 335.42 282.66 337.39 281.47 337.52 280.73 336.85 280.47 334.88 281.68 334.88 279.77 334.34 279.28 333.8 279.77 333.8 282.33 330.29 284.46 330.29 280.2 332.4 278.92 332.52 278.18 331.86 277.92 330.29 278.88 330.29 276.48 329.76 276 329.21 276.48 329.21 278.88 327.65 277.92 326.98 278.18 327.11 278.92 329.21 280.2 329.21 284.46 325.72 282.33 325.72 279.77 325.17 279.28 324.63 279.77 324.63 281.68",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M358.41,340c-.14,0-.28-.05-.4-.14-.28-.23-.34-.65-.12-.94,2.35-3.13,3.24-5.58,2.57-7.07-.29-.66-.84-1.06-1.47-1.52-.8-.58-1.7-1.24-2.18-2.55-.57-1.54-.32-3.36.73-5.43.17-.33.56-.45.88-.28.32.17.44.58.27.9-.87,1.71-1.09,3.17-.67,4.34.34.92,1.01,1.41,1.71,1.93.72.52,1.46,1.07,1.9,2.05.91,2.03.02,4.79-2.73,8.45-.13.17-.32.26-.52.26Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.65,340c-.14,0-.28-.05-.4-.14-.28-.23-.34-.65-.12-.94,2.35-3.13,3.24-5.58,2.57-7.07-.29-.66-.84-1.06-1.47-1.52-.8-.58-1.7-1.24-2.18-2.55-.57-1.54-.32-3.36.73-5.43.17-.33.56-.45.88-.28.32.17.44.58.27.9-.87,1.71-1.09,3.17-.67,4.34.34.92,1.01,1.41,1.71,1.93.72.52,1.46,1.07,1.9,2.05.91,2.03.02,4.79-2.73,8.45-.13.17-.32.26-.52.26Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.88,340c-.14,0-.28-.05-.4-.14-.28-.23-.34-.65-.12-.94,2.35-3.13,3.24-5.58,2.57-7.07-.29-.66-.84-1.06-1.47-1.52-.8-.58-1.7-1.24-2.18-2.55-.57-1.54-.32-3.36.73-5.43.17-.33.56-.45.88-.28.32.17.44.58.27.9-.87,1.71-1.09,3.17-.67,4.34.34.92,1.01,1.41,1.71,1.93.72.52,1.46,1.07,1.9,2.05.91,2.03.02,4.79-2.73,8.45-.13.17-.32.26-.52.26Z",
    fill: "#fff"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.33,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.69,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.04,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.4,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.75,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.11,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.47,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.82,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.18,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.53,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 407.89,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.25,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.6,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.96,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 513.31,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 539.67,
    cy: 461.94,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566,
    cy: 435.43,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566,
    cy: 408.87,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566,
    cy: 382.32,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566,
    cy: 355.77,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566,
    cy: 329.22,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566,
    cy: 302.67,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566,
    cy: 276.11,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566,
    cy: 249.56,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566,
    cy: 223.01,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566,
    cy: 196.46,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.64,169.95c0-1.1.91-2,2.03-2,1.12,0,2.03.9,2.03,2s-.91,2-2.03,2-2.03-.9-2.03-2Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.29,169.96c0-1.1.91-2,2.03-2s2.03.9,2.03,2-.91,2-2.03,2-2.03-.9-2.03-2Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.93,169.96c0-1.1.91-2,2.03-2,1.12,0,2.03.9,2.03,2s-.91,2-2.03,2c-1.12,0-2.03-.9-2.03-2Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.57,169.97c0-1.1.91-2,2.03-2,1.12,0,2.03.9,2.03,2s-.91,2-2.03,2-2.03-.9-2.03-2Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.25,
    cy: 169.97,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 407.89,
    cy: 169.97,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.53,
    cy: 169.98,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.18,
    cy: 169.98,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.79,169.99c0-1.1.91-2,2.03-2,1.12,0,2.03.9,2.03,2,0,1.1-.91,2-2.03,2-1.12,0-2.03-.9-2.03-2Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.44,169.99c0-1.1.91-2,2.03-2,1.12,0,2.03.9,2.03,2s-.91,2-2.03,2c-1.12,0-2.03-.9-2.03-2Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.08,170c0-1.1.91-2,2.03-2,1.12,0,2.03.9,2.03,2s-.91,2-2.03,2-2.03-.9-2.03-2Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.73,170c0-1.1.91-2,2.03-2,1.12,0,2.03.9,2.03,2s-.91,2-2.03,2c-1.12,0-2.03-.9-2.03-2Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.4,
    cy: 170,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.04,
    cy: 170.01,
    rx: 2.03,
    ry: 2,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.66,170.01c0-1.1.91-2,2.03-2,1.12,0,2.03.9,2.03,2s-.91,2-2.03,2c-1.12,0-2.03-.9-2.03-2Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.3,170.02c0-1.1.91-2,2.03-2,1.12,0,2.03.9,2.03,2s-.91,2-2.03,2c-1.12,0-2.03-.9-2.03-2Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 196.52,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 223.07,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 249.61,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 276.16,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 302.71,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 329.25,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 355.8,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 382.34,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 408.89,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 435.43,
    rx: 2,
    ry: 2.04,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "568 461.94 568 462.04 567.99 462.14 567.98 462.24 567.96 462.34 567.94 462.44 567.91 462.53 567.88 462.62 567.84 462.71 567.8 462.8 567.76 462.89 567.71 462.97 567.66 463.05 567.6 463.13 567.54 463.21 567.48 463.28 567.41 463.35 567.34 463.42 567.27 463.48 567.2 463.54 567.12 463.59 567.04 463.65 566.95 463.69 566.87 463.74 566.78 463.78 566.69 463.81 566.59 463.85 566.5 463.87 566.4 463.89 566.3 463.91 566.2 463.92 566.1 463.93 566 463.94 565.9 463.93 565.79 463.92 565.69 463.91 565.6 463.89 565.5 463.87 565.4 463.85 565.31 463.81 565.22 463.78 565.13 463.74 565.05 463.69 564.96 463.65 564.88 463.59 564.8 463.54 564.73 463.48 564.65 463.42 564.59 463.35 564.52 463.28 564.46 463.21 564.4 463.13 564.34 463.05 564.29 462.97 564.24 462.89 564.2 462.8 564.16 462.71 564.12 462.62 564.09 462.53 564.06 462.44 564.04 462.34 564.02 462.24 564.01 462.14 564 462.04 564 461.94 564 461.83 564.01 461.73 564.02 461.63 564.04 461.53 564.06 461.44 564.09 461.34 564.12 461.25 564.16 461.16 564.2 461.07 564.24 460.98 564.29 460.9 564.34 460.82 564.4 460.74 564.46 460.66 564.52 460.59 564.59 460.52 564.65 460.45 564.73 460.39 564.8 460.33 564.88 460.28 564.96 460.22 565.05 460.18 565.13 460.13 565.22 460.09 565.31 460.06 565.4 460.03 565.5 460 565.6 459.98 565.69 459.96 565.79 459.95 565.9 459.94 566 459.94 566.1 459.94 566.2 459.95 566.3 459.96 566.4 459.98 566.5 460 566.59 460.03 566.69 460.06 566.78 460.09 566.87 460.13 566.95 460.18 567.04 460.22 567.12 460.28 567.2 460.33 567.27 460.39 567.34 460.45 567.41 460.52 567.48 460.59 567.54 460.66 567.6 460.74 567.66 460.82 567.71 460.9 567.76 460.98 567.8 461.07 567.84 461.16 567.88 461.25 567.91 461.34 567.94 461.44 567.96 461.53 567.98 461.63 567.99 461.73 568 461.83 568 461.94",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "566 459.94 566.1 459.94 566.2 459.95 566.3 459.96 566.4 459.98 566.5 460 566.59 460.03 566.69 460.06 566.78 460.09 566.87 460.13 566.95 460.18 567.04 460.22 567.12 460.28 567.2 460.33 567.27 460.39 567.34 460.45 567.41 460.52 567.48 460.59 567.54 460.66 567.6 460.74 567.66 460.82 567.71 460.9 567.76 460.98 567.8 461.07 567.84 461.16 567.88 461.25 567.91 461.34 567.94 461.44 567.96 461.53 567.98 461.63 567.99 461.73 568 461.83 568 461.94 568 462.04 567.99 462.14 567.98 462.24 567.96 462.34 567.94 462.44 567.91 462.53 567.88 462.62 567.84 462.71 567.8 462.8 567.76 462.89 567.71 462.97 567.66 463.05 567.6 463.13 567.54 463.21 567.48 463.28 567.41 463.35 567.34 463.42 567.27 463.48 567.2 463.54 567.12 463.59 567.04 463.65 566.95 463.69 566.87 463.74 566.78 463.78 566.69 463.81 566.59 463.85 566.5 463.87 566.4 463.89 566.3 463.91 566.2 463.92 566.1 463.93 566 463.94 565.9 463.93 565.79 463.92 565.69 463.91 565.6 463.89 565.5 463.87 565.4 463.85 565.31 463.81 565.22 463.78 565.13 463.74 565.05 463.69 564.96 463.65 564.88 463.59 564.8 463.54 564.73 463.48 564.65 463.42 564.59 463.35 564.52 463.28 564.46 463.21 564.4 463.13 564.34 463.05 564.29 462.97 564.24 462.89 564.2 462.8 564.16 462.71 564.12 462.62 564.09 462.53 564.06 462.44 564.04 462.34 564.02 462.24 564.01 462.14 564 462.04 564 461.94 564 461.83 564.01 461.73 564.02 461.63 564.04 461.53 564.06 461.44 564.09 461.34 564.12 461.25 564.16 461.16 564.2 461.07 564.24 460.98 564.29 460.9 564.34 460.82 564.4 460.74 564.46 460.66 564.52 460.59 564.59 460.52 564.65 460.45 564.73 460.39 564.8 460.33 564.88 460.28 564.96 460.22 565.05 460.18 565.13 460.13 565.22 460.09 565.31 460.06 565.4 460.03 565.5 460 565.6 459.98 565.69 459.96 565.79 459.95 565.9 459.94 566 459.94",
    fill: "#787878"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "566 167.95 566.1 167.95 566.2 167.96 566.3 167.97 566.4 167.99 566.5 168.01 566.59 168.04 566.69 168.07 566.78 168.1 566.87 168.14 566.95 168.19 567.04 168.24 567.12 168.29 567.2 168.34 567.27 168.4 567.34 168.47 567.41 168.53 567.48 168.6 567.54 168.68 567.6 168.75 567.66 168.83 567.71 168.91 567.76 168.99 567.8 169.08 567.84 169.17 567.88 169.26 567.91 169.35 567.94 169.45 567.96 169.54 567.98 169.64 567.99 169.74 568 169.84 568 169.95 568 170.05 567.99 170.15 567.98 170.25 567.96 170.35 567.94 170.45 567.91 170.54 567.88 170.64 567.84 170.73 567.8 170.81 567.76 170.9 567.71 170.98 567.66 171.07 567.6 171.14 567.54 171.22 567.48 171.29 567.41 171.36 567.34 171.43 567.27 171.49 567.2 171.55 567.12 171.61 567.04 171.66 566.95 171.71 566.87 171.75 566.78 171.79 566.69 171.83 566.59 171.86 566.5 171.89 566.4 171.91 566.3 171.92 566.2 171.94 566.1 171.95 566 171.95 565.9 171.95 565.79 171.94 565.69 171.92 565.6 171.91 565.5 171.89 565.4 171.86 565.31 171.83 565.22 171.79 565.13 171.75 565.05 171.71 564.96 171.66 564.88 171.61 564.8 171.55 564.73 171.49 564.65 171.43 564.59 171.36 564.52 171.29 564.46 171.22 564.4 171.14 564.34 171.07 564.29 170.99 564.24 170.9 564.2 170.82 564.16 170.73 564.12 170.64 564.09 170.54 564.06 170.45 564.04 170.35 564.02 170.25 564.01 170.15 564 170.05 564 169.95 564 169.85 564.01 169.74 564.02 169.64 564.04 169.54 564.06 169.45 564.09 169.35 564.12 169.26 564.16 169.17 564.2 169.08 564.24 168.99 564.29 168.91 564.34 168.83 564.4 168.75 564.46 168.68 564.52 168.6 564.58 168.53 564.65 168.47 564.73 168.4 564.8 168.35 564.88 168.29 564.96 168.24 565.05 168.19 565.13 168.15 565.22 168.1 565.31 168.07 565.4 168.04 565.5 168.01 565.6 167.99 565.69 167.97 565.79 167.96 565.9 167.95 566 167.95",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "564 169.95 564 169.85 564.01 169.74 564.02 169.64 564.04 169.54 564.06 169.45 564.09 169.35 564.12 169.26 564.16 169.17 564.2 169.08 564.24 168.99 564.29 168.91 564.34 168.83 564.4 168.75 564.46 168.68 564.52 168.6 564.58 168.53 564.65 168.47 564.73 168.4 564.8 168.35 564.88 168.29 564.96 168.24 565.05 168.19 565.13 168.15 565.22 168.1 565.31 168.07 565.4 168.04 565.5 168.01 565.6 167.99 565.69 167.97 565.79 167.96 565.9 167.95 566 167.95 566.1 167.95 566.2 167.96 566.3 167.97 566.4 167.99 566.5 168.01 566.59 168.04 566.69 168.07 566.78 168.1 566.87 168.14 566.95 168.19 567.04 168.24 567.12 168.29 567.2 168.34 567.27 168.4 567.34 168.47 567.41 168.53 567.48 168.6 567.54 168.68 567.6 168.75 567.66 168.83 567.71 168.91 567.76 168.99 567.8 169.08 567.84 169.17 567.88 169.26 567.91 169.35 567.94 169.45 567.96 169.54 567.98 169.64 567.99 169.74 568 169.84 568 169.95 568 170.05 567.99 170.15 567.98 170.25 567.96 170.35 567.94 170.45 567.91 170.54 567.88 170.64 567.84 170.73 567.8 170.81 567.76 170.9 567.71 170.98 567.66 171.07 567.6 171.14 567.54 171.22 567.48 171.29 567.41 171.36 567.34 171.43 567.27 171.49 567.2 171.55 567.12 171.61 567.04 171.66 566.95 171.71 566.87 171.75 566.78 171.79 566.69 171.83 566.59 171.86 566.5 171.89 566.4 171.91 566.3 171.92 566.2 171.94 566.1 171.95 566 171.95 565.9 171.95 565.79 171.94 565.69 171.92 565.6 171.91 565.5 171.89 565.4 171.86 565.31 171.83 565.22 171.79 565.13 171.75 565.05 171.71 564.96 171.66 564.88 171.61 564.8 171.55 564.73 171.49 564.65 171.43 564.59 171.36 564.52 171.29 564.46 171.22 564.4 171.14 564.34 171.07 564.29 170.99 564.24 170.9 564.2 170.82 564.16 170.73 564.12 170.64 564.09 170.54 564.06 170.45 564.04 170.35 564.02 170.25 564.01 170.15 564 170.05 564 169.95",
    fill: "#787878"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "116 170.02 116 169.92 116.01 169.82 116.02 169.72 116.04 169.62 116.06 169.52 116.09 169.43 116.12 169.33 116.16 169.24 116.2 169.15 116.24 169.07 116.29 168.98 116.34 168.9 116.4 168.82 116.46 168.75 116.52 168.68 116.59 168.61 116.66 168.54 116.73 168.48 116.8 168.42 116.88 168.36 116.96 168.31 117.05 168.26 117.13 168.22 117.22 168.18 117.31 168.14 117.41 168.11 117.5 168.08 117.6 168.06 117.7 168.04 117.8 168.03 117.9 168.02 118 168.02 118.1 168.02 118.2 168.03 118.3 168.04 118.4 168.06 118.5 168.08 118.59 168.11 118.69 168.14 118.78 168.18 118.87 168.22 118.95 168.26 119.04 168.31 119.12 168.36 119.2 168.42 119.27 168.48 119.34 168.54 119.41 168.61 119.48 168.68 119.54 168.75 119.6 168.82 119.66 168.9 119.71 168.98 119.76 169.07 119.8 169.15 119.84 169.24 119.88 169.33 119.91 169.43 119.94 169.52 119.96 169.62 119.98 169.72 119.99 169.82 120 169.92 120 170.02 120 170.12 119.99 170.22 119.98 170.32 119.96 170.42 119.94 170.52 119.91 170.62 119.88 170.71 119.84 170.8 119.8 170.89 119.76 170.97 119.71 171.06 119.66 171.14 119.6 171.22 119.54 171.29 119.48 171.37 119.41 171.43 119.35 171.5 119.27 171.56 119.2 171.62 119.12 171.68 119.04 171.73 118.95 171.78 118.87 171.82 118.78 171.86 118.69 171.9 118.6 171.93 118.5 171.96 118.4 171.98 118.31 172 118.2 172.01 118.1 172.02 118 172.02 117.9 172.02 117.8 172.01 117.7 172 117.6 171.98 117.5 171.96 117.41 171.93 117.31 171.9 117.22 171.86 117.13 171.82 117.05 171.78 116.96 171.73 116.88 171.68 116.8 171.62 116.73 171.56 116.66 171.5 116.59 171.43 116.52 171.37 116.46 171.29 116.4 171.22 116.34 171.14 116.29 171.06 116.24 170.97 116.2 170.89 116.16 170.8 116.12 170.71 116.09 170.62 116.06 170.52 116.04 170.42 116.02 170.33 116.01 170.23 116 170.12 116 170.02",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "118 172.02 117.9 172.02 117.8 172.01 117.7 172 117.6 171.98 117.5 171.96 117.41 171.93 117.31 171.9 117.22 171.86 117.13 171.82 117.05 171.78 116.96 171.73 116.88 171.68 116.8 171.62 116.73 171.56 116.66 171.5 116.59 171.43 116.52 171.37 116.46 171.29 116.4 171.22 116.34 171.14 116.29 171.06 116.24 170.97 116.2 170.89 116.16 170.8 116.12 170.71 116.09 170.62 116.06 170.52 116.04 170.42 116.02 170.33 116.01 170.23 116 170.12 116 170.02 116 169.92 116.01 169.82 116.02 169.72 116.04 169.62 116.06 169.52 116.09 169.43 116.12 169.33 116.16 169.24 116.2 169.15 116.24 169.07 116.29 168.98 116.34 168.9 116.4 168.82 116.46 168.75 116.52 168.68 116.59 168.61 116.66 168.54 116.73 168.48 116.8 168.42 116.88 168.36 116.96 168.31 117.05 168.26 117.13 168.22 117.22 168.18 117.31 168.14 117.41 168.11 117.5 168.08 117.6 168.06 117.7 168.04 117.8 168.03 117.9 168.02 118 168.02 118.1 168.02 118.2 168.03 118.3 168.04 118.4 168.06 118.5 168.08 118.59 168.11 118.69 168.14 118.78 168.18 118.87 168.22 118.95 168.26 119.04 168.31 119.12 168.36 119.2 168.42 119.27 168.48 119.34 168.54 119.41 168.61 119.48 168.68 119.54 168.75 119.6 168.82 119.66 168.9 119.71 168.98 119.76 169.07 119.8 169.15 119.84 169.24 119.88 169.33 119.91 169.43 119.94 169.52 119.96 169.62 119.98 169.72 119.99 169.82 120 169.92 120 170.02 120 170.12 119.99 170.22 119.98 170.32 119.96 170.42 119.94 170.52 119.91 170.62 119.88 170.71 119.84 170.8 119.8 170.89 119.76 170.97 119.71 171.06 119.66 171.14 119.6 171.22 119.54 171.29 119.48 171.37 119.41 171.43 119.35 171.5 119.27 171.56 119.2 171.62 119.12 171.68 119.04 171.73 118.95 171.78 118.87 171.82 118.78 171.86 118.69 171.9 118.6 171.93 118.5 171.96 118.4 171.98 118.31 172 118.2 172.01 118.1 172.02 118 172.02",
    fill: "#787878"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "118 463.94 117.9 463.93 117.8 463.92 117.7 463.91 117.6 463.89 117.5 463.87 117.41 463.85 117.31 463.81 117.22 463.78 117.13 463.74 117.05 463.69 116.96 463.65 116.88 463.59 116.8 463.54 116.73 463.48 116.66 463.42 116.59 463.35 116.52 463.28 116.46 463.21 116.4 463.13 116.34 463.05 116.29 462.97 116.24 462.89 116.2 462.8 116.16 462.71 116.12 462.62 116.09 462.53 116.06 462.44 116.04 462.34 116.02 462.24 116.01 462.14 116 462.04 116 461.94 116 461.83 116.01 461.73 116.02 461.63 116.04 461.53 116.06 461.44 116.09 461.34 116.12 461.25 116.16 461.16 116.2 461.07 116.24 460.98 116.29 460.9 116.34 460.82 116.4 460.74 116.46 460.66 116.52 460.59 116.59 460.52 116.66 460.45 116.73 460.39 116.8 460.33 116.88 460.28 116.96 460.22 117.05 460.18 117.13 460.13 117.22 460.09 117.31 460.06 117.41 460.03 117.5 460 117.6 459.98 117.7 459.96 117.8 459.95 117.9 459.94 118 459.94 118.1 459.94 118.2 459.95 118.31 459.96 118.4 459.98 118.5 460 118.6 460.03 118.69 460.06 118.78 460.09 118.87 460.13 118.95 460.18 119.04 460.22 119.12 460.28 119.2 460.33 119.27 460.39 119.35 460.45 119.41 460.52 119.48 460.59 119.54 460.66 119.6 460.74 119.66 460.82 119.71 460.9 119.76 460.98 119.8 461.07 119.84 461.16 119.88 461.25 119.91 461.34 119.94 461.44 119.96 461.53 119.98 461.63 119.99 461.73 120 461.83 120 461.94 120 462.04 119.99 462.14 119.98 462.24 119.96 462.34 119.94 462.44 119.91 462.53 119.88 462.62 119.84 462.71 119.8 462.8 119.76 462.89 119.71 462.97 119.66 463.05 119.6 463.13 119.54 463.21 119.48 463.28 119.41 463.35 119.35 463.42 119.27 463.48 119.2 463.54 119.12 463.59 119.04 463.65 118.95 463.69 118.87 463.74 118.78 463.78 118.69 463.81 118.6 463.85 118.5 463.87 118.4 463.89 118.31 463.91 118.2 463.92 118.1 463.93 118 463.94",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "120 461.94 120 462.04 119.99 462.14 119.98 462.24 119.96 462.34 119.94 462.44 119.91 462.53 119.88 462.62 119.84 462.71 119.8 462.8 119.76 462.89 119.71 462.97 119.66 463.05 119.6 463.13 119.54 463.21 119.48 463.28 119.41 463.35 119.35 463.42 119.27 463.48 119.2 463.54 119.12 463.59 119.04 463.65 118.95 463.69 118.87 463.74 118.78 463.78 118.69 463.81 118.6 463.85 118.5 463.87 118.4 463.89 118.31 463.91 118.2 463.92 118.1 463.93 118 463.94 117.9 463.93 117.8 463.92 117.7 463.91 117.6 463.89 117.5 463.87 117.41 463.85 117.31 463.81 117.22 463.78 117.13 463.74 117.05 463.69 116.96 463.65 116.88 463.59 116.8 463.54 116.73 463.48 116.66 463.42 116.59 463.35 116.52 463.28 116.46 463.21 116.4 463.13 116.34 463.05 116.29 462.97 116.24 462.89 116.2 462.8 116.16 462.71 116.12 462.62 116.09 462.53 116.06 462.44 116.04 462.34 116.02 462.24 116.01 462.14 116 462.04 116 461.94 116 461.83 116.01 461.73 116.02 461.63 116.04 461.53 116.06 461.44 116.09 461.34 116.12 461.25 116.16 461.16 116.2 461.07 116.24 460.98 116.29 460.9 116.34 460.82 116.4 460.74 116.46 460.66 116.52 460.59 116.59 460.52 116.66 460.45 116.73 460.39 116.8 460.33 116.88 460.28 116.96 460.22 117.05 460.18 117.13 460.13 117.22 460.09 117.31 460.06 117.41 460.03 117.5 460 117.6 459.98 117.7 459.96 117.8 459.95 117.9 459.94 118 459.94 118.1 459.94 118.2 459.95 118.31 459.96 118.4 459.98 118.5 460 118.6 460.03 118.69 460.06 118.78 460.09 118.87 460.13 118.95 460.18 119.04 460.22 119.12 460.28 119.2 460.33 119.27 460.39 119.35 460.45 119.41 460.52 119.48 460.59 119.54 460.66 119.6 460.74 119.66 460.82 119.71 460.9 119.76 460.98 119.8 461.07 119.84 461.16 119.88 461.25 119.91 461.34 119.94 461.44 119.96 461.53 119.98 461.63 119.99 461.73 120 461.83 120 461.94",
    fill: "#787878"
  })))))));
};
export default SvgEGeneralEmissionTabsRoom;